import {errors} from './errors';
import { global, validation } from "./global";
import {
    login,
    registration,
    authorize,
    devices,
    checks,
    issuesPage,
    reports,
    user,
    settings,
    calendar,
    documents,
    locations,
    tenants,
    testTools,
    settingsPage,
    menu,
    correctiveActions
} from './pages';
import {notifications} from './notifications';

export const en = {
    errors,
    global,
    validation,
    notifications,

    //  Pages
    login,
    registration,
    authorize,
    devices,
    checks,
    issues: issuesPage,
    reports,
    user,
    settings,
    calendar,
    documents,
    locations,
    tenants,
    testTools,
    settingsPage,
    menu,
    correctiveActions
};
